import * as React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";

export default function Breadcrumbss({ items }) {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      {items.map((item, index) =>
        index < items.length - 1 ? (
          <Link
            key={index}
            underline="hover"
            color="inherit"
            href={item.href}
            onClick={(e) => {
              // If onClick is provided, use it instead of default href behavior
              if (item.onClick) {
                e.preventDefault();
                item.onClick();
              }
            }}
            sx={{ cursor: 'pointer' }}
          >
            {item.label}
          </Link>
        ) : (
          <Typography key={index} sx={{ color: "text.primary" }}>
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  );
}